export const SET_CHANNEL_VIEW = "SET_CHANNEL_VIEW";

export function setChannelView(view) {
  return {
    type: SET_CHANNEL_VIEW,
    payload: view
  };
}
